export default "__VITE_ASSET__Uh0XKYa5__"